/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Generate_Tailored_ResumeInputs */

const en_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Tailored Resume`)
};

const de_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angepassten Lebenslauf generieren`)
};

const fr_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer un CV adapté`)
};

const es_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar currículum adaptado`)
};

const it_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera curriculum personalizzato`)
};

const nl_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer op maat gemaakt CV`)
};

const pl_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj spersonalizowane CV`)
};

const fi_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo räätälöity ansioluettelo`)
};

const da_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer skræddersyet CV`)
};

const sv_jobs_generate_tailored_resume = /** @type {(inputs: Jobs_Generate_Tailored_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera skräddarsytt CV`)
};

/**
* | output |
* | --- |
* | "Generate Tailored Resume" |
*
* @param {Jobs_Generate_Tailored_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_generate_tailored_resume = /** @type {((inputs?: Jobs_Generate_Tailored_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Generate_Tailored_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_generate_tailored_resume(inputs)
	if (locale === "fr") return fr_jobs_generate_tailored_resume(inputs)
	if (locale === "es") return es_jobs_generate_tailored_resume(inputs)
	if (locale === "it") return it_jobs_generate_tailored_resume(inputs)
	if (locale === "nl") return nl_jobs_generate_tailored_resume(inputs)
	if (locale === "pl") return pl_jobs_generate_tailored_resume(inputs)
	if (locale === "fi") return fi_jobs_generate_tailored_resume(inputs)
	if (locale === "da") return da_jobs_generate_tailored_resume(inputs)
	if (locale === "sv") return sv_jobs_generate_tailored_resume(inputs)
	return en_jobs_generate_tailored_resume(inputs)
});